import { permissionsByEntity, useCheckPermissions } from '@cmg/auth';

const useHasMyOrders = () => {
  return useCheckPermissions([permissionsByEntity.CoveredAccountsInstitutionalIndication.READ]);
};

export default useHasMyOrders;
